import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import {  CURD_L2_MENU_PERMISSIONS_CHR, GET_L2_MENU_PERMISSIONS_ROLE_CHR, CURD_L2_SERVICE_PERMISSIONS_CHR, GET_L2_SERVICE_PERMISSIONS_ROLE_CHR } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL2MenuPermissionChr = createAsyncThunk(
  "l2AccessPermission/createL2MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post( CURD_L2_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL2MenuPermissionChr = createAsyncThunk("l2AccessPermission/getL2MenuPermissionChr", async () => {
  return axios.get( CURD_L2_MENU_PERMISSIONS_CHR, { withCredentials: true });
});

export const getL2MenuPermissionChrRole = createAsyncThunk("l2AccessPermission/getL2MenuPermissionChrRole", async (id) => {
  return axios.get(`${GET_L2_MENU_PERMISSIONS_ROLE_CHR}/${id}`, { withCredentials: true });
});

export const updateL2MenuPermissionChr = createAsyncThunk(
  "l2AccessPermission/updateL2MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put( CURD_L2_MENU_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL2MenuPermissionChr = createAsyncThunk(
  "l2AccessPermission/deleteL2MenuPermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete( CURD_L2_MENU_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createL2ServicePermissionChr = createAsyncThunk(
  "l2AccessPermission/createL2ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L2_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const  getL2ServicePermissionChr = createAsyncThunk("l2AccessPermission/ getL2ServicePermissionChr", async () => {
  return axios.get(CURD_L2_SERVICE_PERMISSIONS_CHR, { withCredentials: true });
});

export const getL2ServicePermissionRoleChr = createAsyncThunk("l2AccessPermission/getL2ServicePermissionRoleChr", async (id) => {
  return axios.get(`${GET_L2_SERVICE_PERMISSIONS_ROLE_CHR}/${id}`, { withCredentials: true });
});

export const updateL2ServicePermissionChr = createAsyncThunk(
  "l2AccessPermission/updateL2ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L2_SERVICE_PERMISSIONS_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL2ServicePermissionChr = createAsyncThunk(
  "l2AccessPermission/deleteL2ServicePermissionChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L2_SERVICE_PERMISSIONS_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l2AccessPermissionSlice = createSlice({
  name: "l2AccessPermission",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l2MenuPermissionData: [],
    l2MenuPermissionChrData : [],
    l2MenuSelectedData: {},
    l2ServicePermissionData: [],
    l2ServiceSelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    l2MenuRowSelect: (state, action) => {
      state.l2MenuSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
    l2ServiceRowSelect: (state, action) => {
      state.l2ServiceSelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL2MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL2MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL2MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL2MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL2MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2MenuPermissionData = action?.payload?.data;
    },
    [getL2MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL2MenuPermissionChrRole.pending]: (state, action) => {
      state.loading = true;
    },
    [getL2MenuPermissionChrRole.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2MenuPermissionChrData = action?.payload?.data;
    },
    [getL2MenuPermissionChrRole.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL2MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL2MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL2MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL2MenuPermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL2MenuPermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL2MenuPermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [createL2ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL2ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL2ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [ getL2ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [ getL2ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2ServicePermissionData = action?.payload?.data;
    },
    [ getL2ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL2ServicePermissionRoleChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL2ServicePermissionRoleChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2ServicePermissionData = action?.payload?.data;
    },
    [getL2ServicePermissionRoleChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL2ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL2ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL2ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL2ServicePermissionChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL2ServicePermissionChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL2ServicePermissionChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, l2MenuRowSelect, l2ServiceRowSelect } = l2AccessPermissionSlice.actions;
export default l2AccessPermissionSlice.reducer;
